<template>
  <v-app>

    <!-- APP BAR -->
    <v-app-bar color="white">
      <v-container class="d-flex justify-space-between align-center">
        <v-img
          src="https://wtfpublicidad.com/wp-content/uploads/2022/10/GRUPO-MV.png"
          max-width="150"
          contain
        />

        <div>
          <v-btn icon href="https://www.facebook.com/share/12GUzZZtKYD/" target="_blank">
            <v-icon>mdi-facebook</v-icon>
          </v-btn>

          <v-btn icon href="https://wa.link/plk405" target="_blank">
            <v-icon>mdi-whatsapp</v-icon>
          </v-btn>

          <v-btn icon href="https://mx.linkedin.com/company/grupo-mv-distribuciones" target="_blank">
            <v-icon>mdi-linkedin</v-icon>
          </v-btn>
        </div>
      </v-container>
    </v-app-bar>

    <!-- CONTENIDO PRINCIPAL -->
    <v-main>
      <v-container
        class="fill-height d-flex justify-center align-center"
        style="
          background-image: url('https://mvexpress.mx/images/publicidad/patronazul.png');
          background-size: cover;
          background-position: center;
        "
      >

        <!-- REGISTRO -->
        <v-col cols="12" md="4" v-if="!showVerification">
          <v-card variant="flat" class="mx-auto pa-6" elevation="8" rounded="lg">

            <div class="text-center mb-4">
              <v-img
                src="https://mvexpress.mx/images/logosapp/logomv2.png"
                max-width="180"
                contain
                class="mx-auto"
              />
            </div>

            <v-card-title class="text-center">Registro de Clientes</v-card-title>

            <v-card-text>
              <v-form ref="registerForm" v-model="registerValid">

                <v-text-field
                  label="Número de Cliente"
                  v-model="cliente"
                  :rules="[rules.required, rules.clienteSoloNumeros]"
                  prepend-inner-icon="mdi-account"
                />

                <v-text-field
                  label="Correo Electrónico"
                  v-model="email"
                  :rules="[rules.email]"
                  prepend-inner-icon="mdi-email-outline"
                />

                <v-text-field
                  label="Número de Celular"
                  v-model="telefono"
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-message-processing"
                />

                <v-radio-group
                  v-model="validationMethod"
                  row
                  class="mt-2"
                  :rules="[rules.required]"
                >
                  <v-radio label="Validar por correo" value="email" />
                  <v-radio disabled label="Validar por SMS" value="sms" />
                </v-radio-group>

                <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  label="Contraseña"
                  v-model="password"
                  :rules="[rules.required, rules.password]"
                  prepend-inner-icon="mdi-lock-outline"
                  :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append-inner="showPassword = !showPassword"
                />

                <v-checkbox
                  v-model="isAdult"
                  :rules="[v => v || 'Debes confirmar que eres mayor de 18 años']"
                  label="Confirmo que soy mayor de 18 años"
                  class="mt-4"
                />

                <v-btn
                  :disabled="!registerValid || !isAdult"
                  block
                  color="primary"
                  class="mt-4"
                  size="large"
                  @click="register"
                >
                  Registrarse
                </v-btn>

              </v-form>

              <v-btn class="mt-2" color="#0d47a1" block @click="$router.push('/')">
                ⬅ Regresar al inicio
              </v-btn>
            </v-card-text>
      
          </v-card>
        </v-col>

        <!-- VERIFICACIÓN -->
        <v-col cols="12" md="4" v-else>
          <v-card variant="flat" class="mx-auto pa-6" elevation="8" rounded="lg">

            <v-card-title class="text-center">Verificación de Código</v-card-title>

            <v-card-text>
              <v-form ref="verifyForm" lazy-validation>

                <v-otp-input
                  v-model="verificationCode"
                  class="mb-4"
                  length="6"
                  variant="outlined"
                  @update:modelValue="handleOtpInput"
                />

                <v-btn
                  :disabled="verificationCode.length !== 6"
                  block
                  color="primary"
                  class="mt-4"
                  size="large"
                  @click="verifyCode"
                >
                  Verificar Código
                </v-btn>

                <div class="text-center mt-2">
                  <v-btn
                    color="secondary"
                    size="x-small"
                    variant="text"
                    @click="resendCode"
                  >
                    Enviar nuevo código
                  </v-btn>
                </div>
             <v-btn
              class="mt-4"
              color="red-darken-1"
              block
              @click="restartRegister"
            >
              🔄 Comenzar registro nuevamente
            </v-btn>
              </v-form>
            </v-card-text>

          </v-card>
        </v-col>

      </v-container>
    </v-main>

    <!-- FOOTER -->
    <v-footer color="orange" class="d-flex justify-center text-white py-2">
      <v-container class="text-center">
        <span>
          © {{ new Date().getFullYear() }} Grupo MV -
          <a href="/aviso-privacidad" class="text-white text-decoration-underline">
            Aviso de Privacidad
          </a>
        </span>
      </v-container>
    </v-footer>

  </v-app>
</template>


<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      isAdult: false,
      cliente: "",
      email: "",
      telefono: "",
      password: "",
      validationMethod: "", // <-- email o sms
      verificationCode: "",
      registerValid: false,
      verifyValid: false,
      showVerification: false,
      showPassword: false,
      rules: {
        required: (v) => !!v || "Este campo es obligatorio.",
        email: (v) => !v || /.+@.+\..+/.test(v) || "Ingrese un correo válido.",
        clienteSoloNumeros: (v) =>
          !v || /^\d+$/.test(String(v)) || "Solo debe contener números.",
        password: (v) =>
          /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/.test(v) ||
          "Mínimo 6 caracteres, incluyendo una letra y un número.",
        otp6: (v) => /^\d{6}$/.test(v) || "El código debe tener 6 dígitos.",
      },
    };
  },
watch: {
  cliente(val) { localStorage.setItem("reg_cliente", val); },
  email(val) { localStorage.setItem("reg_email", val); },
  telefono(val) { localStorage.setItem("reg_phone", val); },
  password(val) { localStorage.setItem("reg_password", val); },
  validationMethod(val) { localStorage.setItem("reg_validationMethod", val); },
  showVerification(val) { localStorage.setItem("reg_showVerification", val); }
},
mounted() {
  this.cliente = localStorage.getItem("reg_cliente") || "";
  this.email = localStorage.getItem("reg_email") || "";
  this.telefono = localStorage.getItem("reg_phone") || "";
  this.password = localStorage.getItem("reg_password") || "";
  this.validationMethod = localStorage.getItem("reg_validationMethod") || "";
  this.showVerification = localStorage.getItem("reg_showVerification") === "true";
},

  methods: {
    async register() {
      const valid = await this.$refs.registerForm.validate();
      if (!valid) return;
      await this.sendRegisterRequest();
    },

    async resendCode() {
      this.verificationCode = "";
      await this.sendRegisterRequest();
    },
clearRegisterData() {
  localStorage.removeItem("reg_cliente");
  localStorage.removeItem("reg_email");
  localStorage.removeItem("reg_phone");
  localStorage.removeItem("reg_password");
  localStorage.removeItem("reg_validationMethod");
  localStorage.removeItem("reg_showVerification");
},


async sendRegisterRequest() {
  try {
    const payload = {
      cliente: this.cliente,
      password: this.password,
      telefono: this.telefono,
    };
    if (this.validationMethod === "email") payload.email = this.email;
    if (this.validationMethod === "sms") payload.telefono = this.telefono;

    console.log("📤 Payload enviado al backend:", payload);

    const response = await axios.post("https://mvexpress.mx/api/register", payload);

    console.log("📥 Respuesta backend:", response.data);
    const msg = this.validationMethod === "email"
      ? "Se envió un código de verificación a tu correo."
      : "Se envió un código de verificación a tu celular.";

    this.showSwal("success", "Registro exitoso", msg);
    this.clearRegisterData();
    this.showVerification = true;
  } catch (error) {
    console.error("❌ Error axios register:", error.response?.data || error);
    this.handleError(error, "Error al registrar");
  }
},

    handleOtpInput(value) {
      this.verificationCode = value;
      this.verifyValid = value.length === 6 && /^\d{6}$/.test(value);
    },

    async verifyCode() {
      const valid = await this.$refs.verifyForm.validate();
      if (!valid) return;

      try {
        const payload = {
          code: this.verificationCode,
        };

        // Enviamos correo o phone según lo elegido
        if (this.validationMethod === "email") {
          payload.email = this.email;
        } else if (this.validationMethod === "sms") {
          payload.telefono = this.telefono;
        }

        await axios.post("https://mvexpress.mx/api/verify-code", payload);

        this.showSwal("success", "Verificado", "Tu cuenta ha sido verificada correctamente.");
        this.$router.push("/Home");
      } catch (error) {
        this.handleError(error, "Error al verificar");
      }
    },
restartRegister() {
  this.clearRegisterData();
  this.cliente = "";
  this.email = "";
  this.telefono = "";
  this.password = "";
  this.validationMethod = "";
  this.verificationCode = "";
  this.showVerification = false;

  Swal.fire({
    icon: "info",
    title: "Registro reiniciado",
    text: "Puedes comenzar nuevamente.",
    timer: 2500,
    showConfirmButton: false
  });
},

    showSwal(icon, title, text) {
      Swal.fire({
        icon,
        title,
        text,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    },

    handleError(error, defaultTitle) {
      const msg =
        error?.response?.data?.message || "No se pudo conectar con el servidor";
      this.showSwal("error", defaultTitle, msg);
    },
  },
};
</script>
